<template>
  <button @click="login">Login with Salesforce</button>
</template>

<script>
export default {
  methods: {
    buildRedirect() {
      const domain = process.env.VUE_APP_DOMAIN;
      const redirectSignIn = process.env.VUE_APP_REDIRECT;
      const responseType = 'code';
      const clientId = process.env.VUE_APP_CLIENT_ID;

      const signInWithSf = `https://${domain}/oauth2/authorize?redirect_uri=${redirectSignIn}&response_type=${responseType}&client_id=${clientId}&identity_provider=${
        process.env.VUE_APP_IDENTITY_PROVIDER || 'Salesforce'
      }`;

      return signInWithSf;
    },
    async login() {
      // window.open(this.buildRedirect(), 'SFAuthWindow', 'height=800,width=400');
      window.location.href = this.buildRedirect();
    },
  },
};
</script>
<style scoped>
button {
  background: #04a4d6;
  border: 0px;
  color: #fff;
  cursor: pointer;
  font-size: 16px;
  height: 60px;
  padding: 20px;
}
button:hover {
  background: #1dc1f4;
  color: #026382;
}
</style>